<style scoped>
.v-text-field {
  padding-top: 0px !important;
  margin-top: 4px !important;
}

.v-input {
  font-size: 12px !important;
}

.sparkcard {
  cursor: pointer;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
}
.v-btn--small {
    font-size: 10px;
    height: 22px;
    padding: 0 6px 3px 6px;
    margin: 0px 4px;
    min-width: 10px;
}
.caption {
  text-transform: capitalize;
}

.v-card.active {

}
</style>
<template>
<vue-perfect-scrollbar class="scroll-area" :settings="settings">
  <v-container grid-list-sm ma-0 pa-0 style="border: 0px; height: 100% " fluid v-if="chart.chartData.orientation == 'vertical'">
    <!--<v-layout ma-0 pa-0 style="border: 0px" row>-->
    <v-layout ma-0 pa-0 style="border: 0px" row wrap align-center>
      <v-flex :key="index" class="xs12" v-for="(item, index) in chart.chartData.series" v-if="chart.chartData.series.length">
        <v-card v-bind:class="[activeId == item.name ? 'sparkcard active' : 'sparkcard']" v-on:click="setFilter(item.name, chart.chartData.activeFilter)" class="sparkcard" :style="activeId == item.name ? item.activeCanvasStyle : item.canvasStyle">
          <div :class="chart.chartData.fontClass" :style="activeId == item.name ? chart.chartData.activeFontStyle : chart.chartData.fontStyle">
            <div class="caption font-weight-medium" style="display: absolute; top: 20px; left: 10px">
              {{ item.name }}
            </div>
            <div class="display-2">{{ format(item.sum, chart.chartData.format) }}</div>
            <div class="caption font-weight-medium">
              <v-btn v-if="item.change > 0" small green color="green darken-4" dark><v-icon dark>arrow_drop_up</v-icon> {{ format(item.change, '0.00') }}% </v-btn>
              <v-btn v-if="item.change < 0" small green color="red darken-4" dark> <v-icon dark>arrow_drop_down</v-icon> {{ format(item.change, '0.00') }}% </v-btn>
              {{ chart.chartData.title }}
            </div>
          </div>

          <template v-if="displaySparkline && item.dataArray && item.dataArray.length && chart.chartData.displaySparkline">
            <v-sparkline  style="height: 100px;" :value="item.dataArray" :gradient="activeId == item.name ? ['#fff'] : chart.chartData.gradient" :smooth="radius || false" :padding="padding"
              :line-width="width" width="500" :stroke-linecap="lineCap" :gradient-direction="gradientDirection" auto-draw>
            </v-sparkline>
          </template>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container fill-height grid-list-sm ma-0 pa-0 style="border: 0px; height: 100% " fluid v-else>
    <!--<v-layout ma-0 pa-0 style="border: 0px" row>-->
    <v-layout ma-0 pa-0 style="border: 0px" row align-center>
      <v-flex :class="chart.chartData.sizes" style="min-width: 300px;" :key="index" v-for="(item, index) in chart.chartData.series" v-if="chart.chartData.series.length">
        <v-card v-bind:class="[activeId == item.name ? 'sparkcard active' : 'sparkcard']" v-on:click="setFilter(item.name, chart.chartData.activeFilter)" class="sparkcard" :style="activeId == item.name ? item.activeCanvasStyle : item.canvasStyle">
          <div :class="chart.chartData.fontClass" :style="activeId == item.name ? chart.chartData.activeFontStyle : chart.chartData.fontStyle">
            <div class="caption font-weight-medium" style="display: absolute; top: 20px; left: 10px">
              {{ item.name }}
            </div>
            <div class="display-2">{{ format(item.sum, chart.chartData.format) }}</div>
            <div class="caption font-weight-medium">
              <v-btn v-if="item.change > 0" small green color="green darken-4" dark><v-icon dark>arrow_drop_up</v-icon> {{ format(item.change, '0.00') }}% </v-btn>
              <v-btn v-if="item.change < 0" small green color="red darken-4" dark> <v-icon dark>arrow_drop_down</v-icon> {{ format(item.change, '0.00') }}% </v-btn>
              {{ chart.chartData.title }} <span v-if="chart.chartData.transformItem.comparison">({{ chart.chartData.transformItem.comparison }})</span>
            </div>
          </div>

          <template v-if="displaySparkline && item.dataArray && item.dataArray.length && chart.chartData.displaySparkline">
            <v-sparkline style="height: 100px;" :value="item.dataArray" :gradient="activeId == item.name ? ['#fff'] : chart.chartData.gradient" :smooth="radius || false" :padding="padding"
              :line-width="width" width="500" :stroke-linecap="lineCap" :gradient-direction="gradientDirection" :auto-draw="displaySparkline">
            </v-sparkline>
          </template>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</vue-perfect-scrollbar>
</template>
<script>
import numeral from 'numeral';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';


import {
  createNamespacedHelpers
}
from 'vuex';
const chartNamespace = createNamespacedHelpers('charts');

const gradients = [
  ['#222'],
  ['#42b3f4'],
  ['red', 'orange', 'yellow'],
  ['purple', 'violet'],
  ['#00c6ff', '#F0F', '#FF0'],
  ['#f72047', '#ffd200', '#1feaea']
]
export default {
  props: ['chart'],
  data: function() {
    return {
      displaySparkline: false,
      activeId: null,
      settings: {
        maxScrollbarLength: 60
      },
      dateFrom: new Date().toISOString().substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      menu: false,
      menuFrom: false,
      menuTo: false,
      modal: false,
      menu2: false,
      width: 5,
      radius: 10,
      padding: 8,
      lineCap: 'round',
      gradient: gradients[5],
      gradientDirection: 'top',
      gradients
    };
  },
  methods: {
    ...chartNamespace.mapMutations(['mSetFilter', 'mRemoveFilter']),

    setFilter: function(name, activeFilter) {
      console.log("filter 1");
      if (!activeFilter) {
        return false;
      }
      console.log("filter 2");
      // console.log(this.chart.id);
      const filterId = "filter_" + this.chart.id;
      const filter = {
        field: this.chart.chartData.group,
        operator: "=",
        value: name
      };
      const params = {
        id: filterId,
        filter: filter,
        exclude: [this.chart.id]
      };

      if (this.activeId == name) {
        this.activeId = null;
        this.mRemoveFilter(params);
      } else {


        this.mSetFilter(params);
        this.activeId = name;
      }
      // console.log(name);
    },
    rendered: function() {

    },
    format: function(val, format) {
      // console.log("format", format);
      if (!format) {
        return val;
      }
      return numeral(val).format(format);
    }
  },
  computed: {

  },
  components: {
    'vue-perfect-scrollbar': VuePerfectScrollbar

  },
  mounted: function() {
    this.displaySparkline = true;
    console.log("this.chart.chartData", this.chart.chartData);
  }
}
</script>
